import type { NotificationDetailData, NotificationListData, NotificationListItem } from '../resident-notifications/notification-api';
import type { NotificationRecipientsData } from './types';

type MockNotification = NotificationListItem & {
  to?: string | string[];
  from?: string;
};

const mockMessages: MockNotification[] = [
  {
    id: 1,
    createdAt: '2026-05-03T12:56:00',
    subject: 'Документы',
    status: 'read',
    text: 'Уважаемый резидент, напоминаем о необходимости предоставить актуальные документы до конца отчётного периода.',
    to: 'ООО «Компания_Резидент»',
    from: 'manager@intc.ru',
    replies: [
      {
        id: 101,
        createdAt: '2026-05-04T10:15:00',
        text: 'Документы подготовлены и будут загружены в личный кабинет в течение двух рабочих дней.',
        managerReply: false,
      },
    ],
  },
  {
    id: 2,
    createdAt: '2026-05-03T11:20:00',
    subject: 'Отчеты и шаблоны',
    status: 'read',
    text: 'В разделе «Отчеты» доступны обновлённые шаблоны для заполнения.',
    to: 'ООО «Резидент»',
    from: 'manager@intc.ru',
    replies: [],
  },
  {
    id: 3,
    createdAt: '2026-05-03T09:12:00',
    subject: 'О заявке',
    status: 'read',
    text: 'По вашей заявке на бронирование переговорной комнаты сообщаем, что бронь подтверждена.',
    to: 'АО «Компания_Резидента_Имя»',
    from: 'manager@intc.ru',
    replies: [
      {
        id: 102,
        createdAt: '2026-05-03T14:20:00',
        text: 'Спасибо, подтверждаем участие.',
        managerReply: false,
      },
    ],
  },
  {
    id: 4,
    createdAt: '2026-05-02T16:45:00',
    subject: 'Изменение расписания',
    status: 'read',
    text: 'Информируем об изменении расписания работы офиса в праздничные дни.',
    to: 'ООО «Компания_имя»',
    from: 'manager@intc.ru',
    replies: [],
  },
  {
    id: 5,
    createdAt: '2026-05-02T10:30:00',
    subject: 'Новые требования',
    status: 'new',
    text: 'Опубликованы новые требования к отчётности резидентов.',
    to: 'ООО «Компания_Резидент»',
    from: 'manager@intc.ru',
    replies: [],
  },
];

export const mockManagerNotificationRecipients: NotificationRecipientsData = {
  residents: [
    { id: '1', name: 'АО «Компания_Резидента_Имя»' },
    { id: '2', name: 'ООО «Компания_имя»' },
    { id: '3', name: 'ООО «Компания_Резидент»' },
    { id: '4', name: 'ООО «Резидент»' },
    { id: '5', name: 'ООО «Технопарк»' },
  ],
  clusters: [
    { id: '1', name: 'Кластер Ломоносов' },
    { id: '2', name: 'Кластер Воробьёвы горы' },
  ],
};

export function getMockManagerNotificationList(): NotificationListData {
  return {
    messages: mockMessages,
    countNewMessages: 1,
    nav: {
      totalCount: mockMessages.length,
      pageSize: 20,
      currentPage: 1,
      pageCount: 1,
    },
  };
}

export function getMockManagerNotificationDetail(id: number): NotificationDetailData {
  const message = mockMessages.find((item) => item.id === id);

  if (!message) {
    throw new Error('Уведомление не найдено');
  }

  const recipient = Array.isArray(message.to) ? message.to[0] ?? '' : String(message.to ?? '');

  return {
    id: message.id,
    createdAt: message.createdAt,
    subject: message.subject,
    message: message.text.replace(/\n/g, '<br>'),
    status: message.status,
    files: [],
    from: message.from ?? 'manager@intc.ru',
    to: recipient,
  };
}

export async function submitMockManagerNotification(): Promise<{ success: true }> {
  return { success: true };
}
